'use client';

import { useRef, useState } from 'react';
import { Pagination } from '@paypoteam/ui-components/Pagination';

import type { ShareholdersPaginatedListProps } from '../ShareholdersSection.types';
import { getTotalPages, isOnPage } from '../utils/pagination';

import { SHAREHOLDERS_SECTION_CONTENT } from '@/static/content/pl/shareholders';

export default function ShareholdersPaginatedList({
    items,
    'data-test-id': dataTestId,
}: ShareholdersPaginatedListProps) {
    const [currentPage, setCurrentPage] = useState(1);
    const listRef = useRef<HTMLUListElement>(null);

    const totalPages = getTotalPages(items.length);

    const handlePageChange = (page: number) => {
        setCurrentPage(page);
        listRef.current?.scrollIntoView({ block: 'start' });
        listRef.current?.focus({ preventScroll: true });
    };

    return (
        <div className="flex flex-col gap-4">
            <ul
                ref={listRef}
                tabIndex={-1}
                className="flex scroll-mt-24 flex-col gap-4 focus:outline-none"
            >
                {items.map(({ key, node }, index) => (
                    <li
                        key={key}
                        hidden={!isOnPage(index, currentPage)}
                    >
                        {node}
                    </li>
                ))}
            </ul>

            {totalPages > 1 && (
                <Pagination
                    withNumbers
                    currentPage={currentPage}
                    totalPages={totalPages}
                    handleChange={handlePageChange}
                    aria-label={SHAREHOLDERS_SECTION_CONTENT.paginationLabel}
                    className="py-6"
                    data-test-id={dataTestId && `${dataTestId}-pagination`}
                />
            )}
        </div>
    );
}
